import { SystemFuncArgs } from '$legacyecstatic';
import { Components } from 'editor/components';
import DomElement from 'editor/components/DomElement';
import MapboxMap from 'editor/components/map/MapboxMap';
import MapboxMarker from 'editor/components/map/MapboxMarker';
import { Marker } from 'mapbox-gl';

export const manageMarkerComponents = [MapboxMap, MapboxMarker, DomElement];

export function manageMarker(args: SystemFuncArgs<Components>): void {
  const { entity, components } = args;

  const markerComp = components.get(MapboxMarker);
  const mapComp = components.get(MapboxMap);
  const domElComp = components.get(DomElement);

  if (!mapComp.map) return;

  if (!markerComp.mounted) {
    markerComp.marker = new Marker({
      element: domElComp.element,
      anchor: 'top',
    });

    markerComp.marker
      .setLngLat([markerComp.lng, markerComp.lat])
      .addTo(mapComp.map);

    markerComp.mounted = true;
  }

  if (markerComp.mounted && markerComp.destroy) {
    // remove marker from the map.
    markerComp.marker?.remove();

    // TEMP: for now just destroying the entity...
    entity.destroy();
  }

  if (markerComp.updated) {
    markerComp.marker?.setLngLat([markerComp.lng, markerComp.lat]);
  }
}
